var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E6F3FF"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDBE6"
    },
    d: "M437.019,437.019c33.568-33.568,55.846-74.142,66.872-117.012L306.079,122.602l-139.147,98.919 l-73.826,55.117l228.274,226.9C363.744,492.392,403.809,470.228,437.019,437.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15D"
    },
    d: "M286.294,284.444H111.928c-14.688,0-26.595-11.907-26.595-26.595V140.372 c0-14.688,11.907-26.595,26.595-26.595h174.364c14.688,0,26.595,11.907,26.595,26.595v117.476 C312.889,272.537,300.982,284.444,286.294,284.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M286.294,113.778h-87.757v170.667h87.757c14.688,0,26.595-11.907,26.595-26.595V140.372 C312.889,125.685,300.982,113.778,286.294,113.778z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.333,
    y: 152.566,
    style: {
      fill: "#324A5E"
    },
    width: 227.556,
    height: 36.202
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.542,
    y: 152.566,
    style: {
      fill: "#2B3B4E"
    },
    width: 114.347,
    height: 36.202
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M380.75,316.733h-26.715v-52.634c0-15.782-12.698-28.624-28.305-28.624s-28.305,12.841-28.305,28.624 v52.634H270.71v-52.634c0-30.513,24.683-55.337,55.02-55.337s55.02,24.824,55.02,55.337V316.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M326.106,208.77v26.724c15.432,0.207,27.929,12.95,27.929,28.603v52.634h26.715v-52.634 C380.75,233.713,356.271,208.977,326.106,208.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6F58"
    },
    d: "M356.99,408.566h-62.519c-23.309,0-42.206-18.896-42.206-42.206v-67.993h146.932v67.993 C399.196,389.67,380.299,408.566,356.99,408.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M326.106,298.367v110.199h30.884c23.309,0,42.206-18.896,42.206-42.206v-67.993L326.106,298.367 L326.106,298.367z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M337.418,341.501c0-6.454-5.232-11.688-11.688-11.688c-6.454,0-11.688,5.232-11.688,11.688 c0,4.206,2.231,7.883,5.565,9.942v15.486c0,3.17,2.569,5.739,5.739,5.739h0.765c3.17,0,5.739-2.569,5.739-5.739v-15.486 C335.188,349.384,337.418,345.707,337.418,341.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M326.106,329.831v42.836h0.007c3.17,0,5.739-2.569,5.739-5.739v-15.486 c3.336-2.058,5.565-5.735,5.565-9.942C337.418,335.172,332.386,330.031,326.106,329.831z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpi);
export default __webpack_public_path__ + "static/media/upi.caf53ec2f19b59a56d83efb206788aae.svg";
export { ForwardRef as ReactComponent };